import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { FromSelectWrapper, FromSelectStyled } from './styled'

const FormSelectLang = ({ onChange }) => {
  const { t, i18n } = useTranslation()

  const handleChange = e => {
    onChange(e.target.value)
  }

  return (
    <FromSelectWrapper>
      <FromSelectStyled
        value=""
        green
        onChange={handleChange}
      >
        <option value="" disabled>{t('demo_different_lang')}</option>
        {i18n.languages && i18n.languages.filter(lang => lang !== i18n.language).map(lang => <option key={lang} value={lang}>DEMO {lang.toUpperCase()}</option>)}
      </FromSelectStyled>
    </FromSelectWrapper>
  )

}

FormSelectLang.propTypes = {
  onChange: PropTypes.func
}

FormSelectLang.defaultProps = {
  onChange: () => { }
}

export default FormSelectLang
